<coop-jatak-form
  [editMode]="true"
  [templateMode]="false"
  [formData]="formData"
  [previousUrl]="previousUrl"
  [successUrl]="successUrl"
  [jatakDefault]="jatakDefault"
></coop-jatak-form>
